import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "@/helpers/get-current-langage";

import "./style.scss";

export const CityName = () => {
	const { t } = useTranslation();
	const lang = getCurrentLanguage();
	const { cityNameAr, cityNameEn } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) =>
			select(WEATHER_STORE).getCityLocationState(),
	);

	return (
		<p className="city-name">
			{t("atLocation")} {lang === "ar" ? cityNameAr : cityNameEn}
		</p>
	);
};

export default CityName;
